export default "__VITE_ASSET__c9e44ed3__"